import React from "react";
import "./index.css";

import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import appRouter from "./routes";
import { GlobalDialogProvider } from "./contexts/GlobalDialogContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <GlobalDialogProvider>
      <RouterProvider router={appRouter} />
    </GlobalDialogProvider>
  </React.StrictMode>,
);
